import { GatsbyLinkProps, Link } from 'gatsby';
import * as React from 'react';
import { getLocalizedSlug } from '../lib';
import { Lang, useLang } from './localize-context';
import { LocationContext } from './location-context';

export const LanguageSwitcher = (
  props: Omit<GatsbyLinkProps<any>, 'to' | 'ref'>
) => {
  const lang = useLang();
  const location = React.useContext(LocationContext);
  const targetLang: Lang = lang === 'en-us' ? 'zh-sg' : 'en-us';
  const linkTarget = getLocalizedSlug(
    targetLang,
    location ? location.pathname : ''
  );

  return (
    <Link {...props} to={linkTarget}>
      {targetLang === 'en-us' ? 'English' : '中文'}
    </Link>
  );
};
